import {BaseModel} from "../models/base.model";
import {ColumnInterface} from "../interfaces/column.interface";

export function Column<T extends BaseModel>(options?: ColumnInterface) {
  return (target: T, propertyKey: string) => {
    target.columns ||= []

    const column: ColumnInterface = {property: propertyKey, column: propertyKey}
    if (typeof options !== 'undefined') {
      if (options.column) {
        column['column'] = options.column
      }
      if (options.model) {
        column['model'] = options.model
      }
    }
    target.columns.push(column)
  }
}
